/** 確認入力・照合に使う正規化済みサービス名（前後空白除去） */
export function serviceDeleteConfirmationExpectedValue(
  serviceName: string | undefined | null
): string {
  return (serviceName ?? "").trim();
}

/**
 * ダイアログ上に表示するラベル（ユーザーが入力すべき文字と一致させる）。
 */
export function serviceDeleteConfirmationDisplayLabel(
  serviceName: string | undefined | null
): string {
  const expected = serviceDeleteConfirmationExpectedValue(serviceName);
  if (expected === "") {
    return "（サービス名が空です。確認欄は空のまま「削除する」で確定）";
  }
  return expected;
}

/**
 * サービス削除確認ダイアログで、入力が削除対象のサービス名と一致するか。
 * 前後の空白は無視する。
 */
export function isServiceDeleteNameConfirmed(
  input: string,
  serviceName: string | undefined | null
): boolean {
  const expected = serviceDeleteConfirmationExpectedValue(serviceName);
  const got = input.trim();
  if (expected === "") {
    return got === "";
  }
  return got === expected;
}
